import { useEffect } from 'react';
import { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';

export const useSmoothVisibility = (isVisible: boolean, duration = 300) => {
  const visibility = useSharedValue(isVisible ? 1 : 0);

  useEffect(() => {
    visibility.set(withTiming(isVisible ? 1 : 0, { duration }));
  }, [duration, isVisible, visibility]);

  const animatedStyle = useAnimatedStyle(() => {
    const progress = visibility.get();

    return {
      opacity: progress,
      transform: [{ scale: 0.9 + progress * 0.1 }],
    };
  });

  return { animatedStyle };
};
